import { MedicationRow } from "../../api/medication.type";
import MedicalRecordSummaryCard from "../medical-records/medical-record-summary-card";
import { formatTimeStampToHumanReadableDate } from "../utls/time";
import { pickRecordValue } from "#/lib/medicalRecords";

type MedicationSummaryCardProps = {
  medication: MedicationRow;
  onClick?: () => void;
};

const formatDate = (value?: string | null) => {
  if (!value || value === "infinity") return undefined;
  try {
    return formatTimeStampToHumanReadableDate(value);
  } catch {
    return undefined;
  }
};

const formatDosage = (medication: MedicationRow) => {
  const dosage = pickRecordValue<number | string>(medication as any, [
    "dosage",
  ]);
  const dosageUnit = pickRecordValue<string>(medication as any, [
    "dosage_unit",
    "dosageUnit",
  ]);
  if (!dosage && !dosageUnit) return undefined;
  return [dosage, dosageUnit].filter(Boolean).join(" ");
};

export function MedicationSummaryCard({ medication, onClick }: MedicationSummaryCardProps) {
  const title =
    pickRecordValue<string>(medication as any, ["name", "reason"]) || "Medication";
  const subtitle = formatDosage(medication);
  const status = pickRecordValue<string>(medication as any, ["status"]);

  const startDate = formatDate(
    pickRecordValue<string>(medication as any, ["start_date", "startDate"])
  );
  const endDate = formatDate(
    pickRecordValue<string>(medication as any, ["end_date", "endDate"])
  );

  const meta = [
    { label: "Started", value: startDate },
    { label: "Ends", value: endDate },
  ];

  return (
    <MedicalRecordSummaryCard
      title={title}
      subtitle={subtitle}
      status={status}
      statusTone={status?.toLowerCase() === "active" ? "success" : "default"}
      meta={meta}
      onClick={onClick}
    />
  );
}

export default MedicationSummaryCard;
